// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__QGvXz","label":"styles_label__k8Wzj","caption":"styles_caption__mplzZ","description":"styles_description__VQf4f","content":"styles_content__7n535"};